export const faq_tr = () => {
  const lang = document.documentElement.lang;
  const translate = {
    'pt-BR': {
      placeholder: 'O que você está procurando?',
    },
    en: {
      placeholder: 'What are you looking for?',
    },
    es: {
      placeholder: '¿Qué estás buscando?',
    },
  };

  return translate[lang];
};
